export const XERO_TRX_TYPE = {
  RECEIVE: 'RECEIVE',
  SPEND: 'SPEND',
};
